/**
 * Public surface of the promotions domain.
 *
 * Consumers of selection state, validation, and promo-code actions
 * should import from here. Display data (PromoCarousel hook + per-type
 * hooks) lives outside the context and is exported from its own
 * modules; this barrel intentionally does NOT re-export display hooks
 * to keep the context vs. data boundary clear.
 */

export * from './types';
export * from './context';
